import {DayPeriod} from '../types'

export const DAY_PERIODS: DayPeriod[] = [1, 2, 3, 7, 28]

export enum StrengthMeasurementTypeName {
  ONE_DAY = 'Comp. Strength - 1 D',
  TWO_DAY = 'Comp. Strength - 2 D',
  THREE_DAY = 'Comp. Strength - 3 D',
  SEVEN_DAY = 'Comp. Strength - 7 D',
  TWENTY_EIGHT_DAY = 'Comp. Strength - 28 D'
}

export const DAY_PERIOD_TO_MEASUREMENT_TYPE_NAME: Record<DayPeriod, StrengthMeasurementTypeName> = {
  1: StrengthMeasurementTypeName.ONE_DAY,
  2: StrengthMeasurementTypeName.TWO_DAY,
  3: StrengthMeasurementTypeName.THREE_DAY,
  7: StrengthMeasurementTypeName.SEVEN_DAY,
  28: StrengthMeasurementTypeName.TWENTY_EIGHT_DAY
}

export const MEASUREMENT_TYPE_NAME_TO_DAY_PERIOD: Record<StrengthMeasurementTypeName, DayPeriod> = {
  [StrengthMeasurementTypeName.ONE_DAY]: 1,
  [StrengthMeasurementTypeName.TWO_DAY]: 2,
  [StrengthMeasurementTypeName.THREE_DAY]: 3,
  [StrengthMeasurementTypeName.SEVEN_DAY]: 7,
  [StrengthMeasurementTypeName.TWENTY_EIGHT_DAY]: 28
}

export function getMeasurementTypeNameForDayPeriod(dayPeriod: DayPeriod): string {
  return DAY_PERIOD_TO_MEASUREMENT_TYPE_NAME[dayPeriod]
}

export function getDayPeriodForMeasurementTypeName(name: string): DayPeriod | null {
  return MEASUREMENT_TYPE_NAME_TO_DAY_PERIOD[name as StrengthMeasurementTypeName] ?? null
}
